import React from "react";
import PropTypes from "prop-types";

import { MicrodataContext } from "config/contexts";
import { STREAM_TYPE, INCLUSION_EDGE_TYPE } from "config/constants";
import StreamAd from "stream/containers/StreamAd";

/**
 * StreamItem
 * This component represents one item in the Stream on axios.com
 * It is consumed by the "PaginatedStream" component.
 * This takes an edge prop which contains a "__typename" key that determines
 * whether to render "StreamAd" component or a "ContentComponent"
 */
export default class StreamItem extends React.Component {
  constructor(props) {
    super(props);
    this.domNode = null;
  }

  componentDidMount() {
    // checking to make sure we are not registering a null node
    if (this.renderItem() !== null) {
      this.props.registerStreamItemNode(
        this.domNode,
        this.props.edge,
        this.props.index
      );
    }
  }

  componentWillUnmount() {
    if (this.renderItem() !== null) {
      this.props.unregisterStreamItemNode(this.domNode);
    }
  }

  renderItem() {
    const ContentComponent = this.props.contentComponent;

    switch (this.props.edge.__typename) {
      case INCLUSION_EDGE_TYPE.CONTENT:
        return (
          <MicrodataContext.Provider
            value={
              !this.props.index ||
              this.props.streamType !== STREAM_TYPE.PERMALINK
            }
          >
            <ContentComponent
              story={this.props.edge.node}
              isFeatured={this.props.edge.isFeatured}
              index={this.props.index}
              stream={this.props.stream}
              edge={this.props.edge}
            />
          </MicrodataContext.Provider>
        );

      case INCLUSION_EDGE_TYPE.AD:
        return <StreamAd node={this.props.edge.node} />;

      default:
        return null;
    }
  }

  render() {
    return (
      <div
        data-testid="stream-item"
        ref={el => {
          this.domNode = el;
        }}
      >
        {this.renderItem()}
      </div>
    );
  }
}

StreamItem.propTypes = {
  edge: PropTypes.shape({
    node: PropTypes.shape({
      __typename: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
    }).isRequired,
  }),
  index: PropTypes.number,
  streamType: PropTypes.oneOf(Object.values(STREAM_TYPE)),
  contentComponent: PropTypes.func,
  registerStreamItemNode: PropTypes.func,
  unregisterStreamItemNode: PropTypes.func,
};
